import { api } from '@/api'

const signup = (user: any) => api.$get('/users/registration', user)

export default signup
